import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  skeletonRow: {
    '& td': {
      padding: '12px 16px',
    },
  },
}));

interface Column {
  id: string;
  label: string;
  align: 'center' | 'left' | 'right';
}

interface PaymentMethodsTableSkeletonProps {
  columns: Column[];
  rows?: number;
}

export const PaymentMethodsTableSkeleton: React.FC<PaymentMethodsTableSkeletonProps> = ({
  columns,
  rows = 5,
}) => {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col.id} align={col.align}>
                <Skeleton variant="text" width="80%" height={24} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, index) => (
            <TableRow key={index} className={classes.skeletonRow}>
              <TableCell><Skeleton variant="text" /></TableCell>
              <TableCell><Skeleton variant="text" width={90} /></TableCell>
              <TableCell><Skeleton variant="text" /></TableCell>
              <TableCell><Skeleton variant="text" width={70} /></TableCell>
              <TableCell><Skeleton variant="text" width={80} /></TableCell>
              <TableCell><Skeleton variant="text" /></TableCell>
              <TableCell>
                <Box display="flex" gridGap={4}>
                  <Skeleton variant="rect" width={60} height={24} style={{ borderRadius: 12 }} />
                  <Skeleton variant="rect" width={60} height={24} style={{ borderRadius: 12 }} />
                </Box>
              </TableCell>
              <TableCell>
                <Skeleton variant="rect" width={40} height={20} style={{ borderRadius: 10 }} />
              </TableCell>
              <TableCell>
                <Box display="flex" gridGap={4} justifyContent="center">
                  <Skeleton variant="circle" width={28} height={28} />
                  <Skeleton variant="circle" width={28} height={28} />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PaymentMethodsTableSkeleton;
